import { inject, type Ref } from 'vue'
import type { CombinedError, UseQueryState } from '@urql/vue'
import type { EnquiryFormContentFragment, InitQuery } from '@/graphql/api'

export const initKey = 'app.plugin.init'

export interface InitPlugin {
    error: Ref<CombinedError | undefined>
    initQueryResponse: UseQueryState<InitQuery>
    isInitialized: Ref<boolean>
    promise: Promise<void>
    enquiryFormContent: Readonly<
        Ref<Record<string, EnquiryFormContentFragment>>
    >
}

export function useInit(): InitPlugin {
    return inject(initKey) as InitPlugin
}
